import React from "react";
import { Grid, Typography, Box, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Link } from "react-router-dom";

import siteData from "../../../_data";
import colorsD from "../../../_theme/base/colors";
const { siteInfo, brand } = siteData;
// Styled components
const StyledListItem = styled(ListItem)({
  padding: 0,
  paddingBottom: 10,
  display: "flex",
  alignItems: "start",
  justifyContent: "start",
  alignContent: "start",
});

const StyledListItemIcon = styled(ListItemIcon)({
  padding: 0,
  margin: 0,
  minWidth: "auto",
});

const ContactInfo = ({ footer1 = colorsD.footerDefault ,customfontsize}) => {
  const contactDetails = [
    {
      type: "email",
      href: `mailto:${siteInfo.email}`,
      value: siteInfo.email,
      icon: <EmailIcon />,
    },
    {
      type: "phone",
      href: `tel:${siteInfo.phone}`,
      value: siteInfo.phone,
      icon: <PhoneIcon />,
    },
    {
      type: "address",
      value: siteInfo.address,
      icon: <LocationOnIcon />,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        flexDirection: "column",
        p: 0,
        m: 0,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          textTransform: "uppercase",
          mb: 2,
          color: footer1.heading,
          textAlign: "start",
          fontSize: `${1.5*customfontsize}px`
        }}
      >
        {brand.name}
      </Typography>
      <Typography
        variant="inherit"
        sx={{
          pb: 2,
          textAlign: "start", // Justify the text
          // Bigger font size
          overflowWrap: "break-word", // Allow breaking long words
          wordBreak: "normal", // Break words according to normal rules
          whiteSpace: "normal",
          color: footer1.body,
                fontSize: `${customfontsize}px`
        }}
      >
        {brand.description}
      </Typography>

      <List>
        {contactDetails.map((item, index) => (
          <StyledListItem key={index}>
            <StyledListItemIcon
              sx={{ color: footer1.body,       fontSize: `${customfontsize}px`  ,padding:"0px",margin: "0px",}}
            >
              {item.icon}
            </StyledListItemIcon>

            <Typography
              variant="inherit"
              component={item.href ? Link : "span"}
              to={item.href || undefined}
              sx={{
                p: 0,
                m: 0,
                pl: 2,
                display: "block",
                lineHeight: "normal",
                marginTop: "0",
                color: footer1.body,
                      fontSize: `${customfontsize}px`
              }}
            >
              {item.value}
            </Typography>
          </StyledListItem>
        ))}
      </List>
    </Box>
  );
};

export default ContactInfo;
